import stripHTML from "./stripHTML";

export function isMjml3(mjml: any) {
  if (mjml.children && mjml.children[0] && mjml.children[0].tagName == "mj-container") {
    return true;
  }

  return false;
}

export function convertMjml3toMjml4(mjml3: any) {
  const mjml = mjml3;

  // Replace mj-container with mj-body
  mjml.children[0].tagName = "mj-body";

  // Update mj-social to v4
  for (const section of mjml.children[0].children) {
    if (section.children) {
      for (const column of section.children) {
        if (column.children) {
          for (const block of column.children) {
            if (block.tagName === "mj-button") {
              block.attributes["inner-padding"] = "10px 25px";
            }

            if (block.tagName == "mj-social") {
              const socialElements = [];
              const display = block.attributes["display"].split(" ");
              for (const socialType of display) {
                const name = socialType.split(":")[0];

                let networkNameSharerFix = name;

                //append -noshare to name because mjml treats this networks as share url by default
                const sharerNetworks = ["facebook", "twitter", "google", "pinterest", "linkedin"];

                if (sharerNetworks.includes(name)) {
                  networkNameSharerFix += "-noshare";
                }

                socialElements.push({
                  tagName: "mj-social-element",
                  attributes: {
                    name: networkNameSharerFix,
                    href: block.attributes[name + "-href"],
                    color: block.attributes[name + "-icon-color"],
                    src: block.attributes["base-url"] + name + ".png",
                    "background-color": "transparent",
                  },
                });
                delete block.attributes[name + "-href"];
                delete block.attributes[name + "-icon-color"];
              }

              delete block.attributes["base-url"];
              block.children = socialElements;
            }

            if (block.tagName === "mj-text") {
              const padding = block.attributes["padding"];

              const content = block.content;

              if (content) {
                block.content = content.replace(/&quot;/g, `'`);
              }

              if (padding !== undefined) {
                const paddings = padding.split(" ");

                let paddingTop = parseInt(paddings[0] ? paddings[0].replace("px", "") : 0);
                const paddingRight = parseInt(paddings[1] ? paddings[1].replace("px", "") : 0);
                let paddingBottom = parseInt(paddings[2] ? paddings[2].replace("px", "") : 0);
                const paddingLeft = parseInt(paddings[3] ? paddings[3].replace("px", "") : 0);

                if (
                  block !== undefined &&
                  block.content !== undefined &&
                  block.content.includes("<h1>")
                ) {
                  paddingTop += 10;
                  paddingBottom += 10;
                } else if (
                  block !== undefined &&
                  block.content !== undefined &&
                  block.content.includes("<h3>")
                ) {
                  paddingTop += 16;
                  paddingBottom += 16;
                } else {
                  paddingTop += 13;
                  paddingBottom += 13;
                }

                block.attributes["padding"] =
                  `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`;
              }
            }

            if (block.tagName === "mj-product") {
              block.attributes.layout = block.attributes.layout + ",priceBefore:hide";
              // Must not depend on `document` – this runs on the backend too
              const stripHtml = (html: string) => stripHTML(html);

              const getStylesFor = (type: string) => {
                let styles = "";

                if (block.attributes[`${type}-align`]) {
                  styles += `text-align: ${block.attributes[`${type}-align`]};`;
                }

                if (block.attributes[`${type}-color`]) {
                  styles += `color: ${block.attributes[`${type}-color`]};`;
                }

                if (block.attributes[`${type}-font-size`]) {
                  styles += `font-size: ${block.attributes[`${type}-font-size`]};`;
                }

                if (block.attributes[`${type}-font-family`]) {
                  styles += `font-family: ${block.attributes[`${type}-font-family`]};`;
                }

                return styles;
              };

              // Title conversion
              const title = block.attributes["title"];

              if (title) {
                const rawTitle = stripHtml(title);

                const titleStyles = getStylesFor("title");

                block.attributes["title"] = `<p style="${titleStyles}">${title}</p>`;

                block.attributes["raw-title"] = rawTitle;
              }

              //Description conversion
              const description = block.attributes["description"];

              if (description) {
                const rawDescription = stripHtml(description);

                const descriptionStyles = getStylesFor("description");

                block.attributes.description = `<p style="${descriptionStyles}">${description}</p>`;
                block.attributes["raw-description"] = rawDescription;
              }
              // Price conversion
              // We can safly ignore prefix because ecomail uses only "Kc"

              const price = block.attributes["price"];

              if (price) {
                const priceSuffix = block.attributes["price-suffix"];

                const priceWithSuffix = `${price.toString()} ${priceSuffix}`;

                const priceStyles = getStylesFor("price");

                block.attributes["price"] = `<p style="${priceStyles}">${priceWithSuffix}</p>`;
                block.attributes["raw-price"] = priceWithSuffix;
              }
              // Price haven't existed before
              block.attributes["price-before"] = "*|PRODUCT_PRICE_BEFORE|*";
              block.attributes["raw-price-before"] = "*|PRODUCT_PRICE_BEFORE|*";
            }

            if (block.tagName === "mj-divider") {
              if (
                block.attributes["border-width"] &&
                typeof block.attributes["border-width"] === "number"
              ) {
                block.attributes["border-width"] = block.attributes["border-width"] + "px";
              }

              if (
                block.attributes["padding-top"] &&
                typeof block.attributes["padding-top"] === "number"
              ) {
                block.attributes["padding-top"] = block.attributes["padding-top"] + "px";
              }

              if (
                block.attributes["padding-right"] &&
                typeof block.attributes["padding-right"] === "number"
              ) {
                block.attributes["padding-right"] = block.attributes["padding-right"] + "px";
              }

              if (
                block.attributes["padding-bottom"] &&
                typeof block.attributes["padding-bottom"] === "number"
              ) {
                block.attributes["padding-bottom"] = block.attributes["padding-bottom"] + "px";
              }

              if (
                block.attributes["padding-left"] &&
                typeof block.attributes["padding-left"] === "number"
              ) {
                block.attributes["padding-left"] = block.attributes["padding-left"] + "px";
              }
            }

            for (const attr in block["attributes"]) {
              if (["mj-button", "mj-text"].indexOf(block.tagName) !== -1 && attr == "font-size") {
                if (block.attributes[attr].toString().indexOf("px") == -1) {
                  block["attributes"][attr] += "px";
                }
              }
              if (block.tagName == "mj-spacer" && attr == "height") {
                if (block.attributes[attr].toString().indexOf("px") == -1) {
                  block["attributes"][attr] += "px";
                }
              }
              if (
                block.tagName == "mj-divider" &&
                ["padding-top", "padding-bottom", "padding-left", "padding-right"].indexOf(attr) !==
                  -1
              ) {
                if (
                  block.attributes[attr] &&
                  block.attributes[attr].toString().indexOf("px") == -1
                ) {
                  block["attributes"][attr] += "px";
                }
              }
            }
          }
        }
      }
    }
  }

  return mjml;
}
